// extracted by mini-css-extract-plugin
export default {"PaymentForm":"PaymentForm_PaymentForm__mmCNx","payment":"PaymentForm_payment__D4ZDU","button":"PaymentForm_button__LkPNs"};